<template>
  <div class="d-flex align-items-center mb-4">
    <b-button
      variant="primary"
      v-b-tooltip.hover.right
      title="Selecionar lista de preços de serviços"
      @click="abrirModal"
    >
      <TagOutline :size="20" class="mr-1" />
      Lista de preços
    </b-button>

    <span
      v-if="value && value.descricao"
      class="badge badge-light px-3 py-2 ml-3"
    >
      <strong>Lista selecionada:</strong>
      {{ value.descricao }}
      <button
        type="button"
        class="btn btn-link text-danger p-0 ml-2"
        title="Remover lista selecionada"
        @click="$emit('input', null)"
      >
        <CloseCircleOutline :size="18" />
      </button>
    </span>

    <b-modal
      id="modal-lista-preco-servico"
      title="Selecionar lista de preços de serviços"
      hide-footer
      @shown="carregarListas('')"
    >
      <b-form-group label="Lista de preços">
        <VueSelect
          :filterable="false"
          :options="listas"
          :value="value"
          @input="$emit('input', $event)"
          @search="onSearch"
        >
          <template slot="no-options">
            Nenhuma lista de preços encontrada
          </template>
          <template slot="option" slot-scope="option">
            {{ option.descricao }}
          </template>
          <template slot="selected-option" slot-scope="option">
            {{ option.descricao }}
          </template>
        </VueSelect>
      </b-form-group>

      <div class="d-flex justify-content-end">
        <b-button
          variant="primary"
          @click="$bvModal.hide('modal-lista-preco-servico')"
        >
          Aplicar
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import _ from "lodash";
import VueSelect from "vue-select";
import TagOutline from "vue-material-design-icons/TagOutline.vue";
import CloseCircleOutline from "vue-material-design-icons/CloseCircleOutline.vue";
import "vue-select/dist/vue-select.css";

export default {
  name: "ListaPrecoServicoSelect",
  components: {
    VueSelect,
    TagOutline,
    CloseCircleOutline,
  },
  props: {
    value: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      listas: [],
    };
  },
  methods: {
    abrirModal() {
      this.$bvModal.show("modal-lista-preco-servico");
    },
    onSearch(search, loading) {
      loading(true);
      this.buscarListas(search, loading);
    },
    buscarListas: _.debounce(async function (search, loading) {
      await this.carregarListas(search);
      loading(false);
    }, 350),
    async carregarListas(descricao) {
      const { data } = await this.$http.post("/servicos/lista-preco/ativas", {
        descricao,
      });
      this.listas = data;
    },
  },
};
</script>
